<script lang="ts">
  import Link from '#app/lib/components/link.svelte'
  import { imgSrc } from '#app/lib/image_source'
  import type { ActivityActor } from '#server/types/activity'

  const {
    follower,
  }: {
    follower: ActivityActor
  } = $props()

  function buildAddressLabel () {
    const { id, name, preferredUsername } = follower
    let addressLabel
    const hostname = follower.id.split('/')[2]
    if (preferredUsername) {
      addressLabel = `${preferredUsername}@${hostname}`
    } else if (name) {
      addressLabel = `${name}@${hostname}`
    } else {
      addressLabel = id
    }
    return addressLabel
  }
</script>

<li>
  <a
    href={follower.id}
    class="remote-user"
    target="_blank"
  >
    <span class="user-icon">
      {#if follower.icon}
        <img src={imgSrc(follower.icon.url)} alt="" loading="lazy" />
      {:else}
        <div class="image-placeholder"></div>
      {/if}
    </span>
    <div class="info">
      {#if follower.name}
        <div class="header">
          <span class="username">{follower.name}</span>
        </div>
      {/if}
      <Link
        url={follower.id}
        text={buildAddressLabel()}
      />
    </div>
  </a>
</li>

<style lang="scss">
  @import "general/scss/utils";
  li{
    @include bg-hover($light-grey, 5%);
    margin: 0.5em;
    padding: 0.5em;
  }
  .remote-user{
    @include display-flex(row, center, flex-start);
  }
  .user-icon{
    margin-inline-end: 0.5em;
    width: 3em;
    background-color: $image-placeholder-grey;
  }
  .info{
    position: relative;
    flex: 1;
  }
  .header{
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  img, .image-placeholder{
    flex: 0 0 3em;
    height: 3rem;
    object-fit: cover;
  }
</style>
